// extracted by mini-css-extract-plugin
export default {"headerContainer":"header_headerContainer__UM2qC"};